"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlannerExampleComponent = void 0;
const core_1 = require("@angular/core");
const orders_service_1 = require("@core/services/orders.service");
const panels_service_1 = require("@core/services/panels.service");
const rxjs_1 = require("rxjs");
const i0 = __importStar(require("@angular/core"));
const i1 = __importStar(require("@core/services/panels.service"));
const i2 = __importStar(require("@core/services/orders.service"));
const i3 = __importStar(require("../../../core/controls/a18-date-box/a18-date-box.component"));
const _c0 = ["*"];
class PlannerExampleComponent {
    constructor(_panelsService, _ordersService) {
        this._panelsService = _panelsService;
        this._ordersService = _ordersService;
        this.panels$ = new rxjs_1.Subscription();
        this.panels = {};
        this.selectedDate = new Date();
        this.panelsChange = new core_1.EventEmitter();
    }
    ngOnInit() {
        // subscribe to object registered in related service
        this.panels$ = this._panelsService.panels$.subscribe((panels) => {
            this.panels = panels;
            this.panelsChange.emit(panels);
        });
    }
    onOpenClick() {
        this._ordersService.onOpenPanel();
    }
    onCloseClick() {
        this._panelsService.closePanel();
    }
    ngOnDestroy() {
        // unsubscribe to object on component destruction -> unhandled subscriptions could result in outdated data
        this.panels$.unsubscribe();
    }
}
exports.PlannerExampleComponent = PlannerExampleComponent;
PlannerExampleComponent.ɵfac = function PlannerExampleComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PlannerExampleComponent)(i0.ɵɵdirectiveInject(i1.PanelsService), i0.ɵɵdirectiveInject(i2.OrdersService)); };
PlannerExampleComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlannerExampleComponent, selectors: [["planner-example"]], outputs: { panelsChange: "panelsChange" }, ngContentSelectors: _c0, decls: 12, vars: 0, consts: [[1, "fullBox"], [1, "flexContent", "items-center", "spacebetween", "mb-5"], ["id", "exampleAddNewOrderPlanner", "type", "button", 1, "main_btn", 3, "click"], [1, "fas", "fa-plus"], [1, "boxContent"]], template: function PlannerExampleComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "h1");
        i0.ɵɵtext(3, "Angular container with comunication");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "button", 2);
        i0.ɵɵlistener("click", function PlannerExampleComponent_Template_button_click_4_listener() { return ctx.onOpenClick(); });
        i0.ɵɵelement(5, "i", 3);
        i0.ɵɵtext(6, " Dodaj zlecenie ");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(7, "div", 4);
        i0.ɵɵelement(8, "a18-date-box");
        i0.ɵɵelementStart(9, "h3");
        i0.ɵɵtext(10, "Angular ng-content placement for injecting AngularJs");
        i0.ɵɵelementEnd();
        i0.ɵɵprojection(11);
        i0.ɵɵelementEnd()();
    } }, dependencies: [i3.A18DateBoxComponent], encapsulation: 2 });
